import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Set title immediately before React mounts
document.title = 'Megapack Nutrición Resuelta — Consulta Resuelta™';
// Preconnect to critical origins BEFORE React renders
const origins = ['https://res.cloudinary.com', 'https://images.unsplash.com'];
origins.forEach(href => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
// Preload hero image for faster LCP — MUST match actual src in App.tsx
const preloadImg = document.createElement('link');
preloadImg.rel = 'preload';
preloadImg.as = 'image';
preloadImg.href = 'https://res.cloudinary.com/dowzlbqlz/image/upload/f_auto,q_auto,w_800/v1777434206/hf_20260429_033725_b473d8a2-33c9-41b8-aac8-77366332cd8f-Photoroom_f30vpb.png';
document.head.appendChild(preloadImg);
render(<App data-id="element-463" />, document.getElementById('root'));